import script from "./WaitlistForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitlistForm.vue?vue&type=script&setup=true&lang=js"

import "./WaitlistForm.vue?vue&type=style&index=0&id=00f961fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f961fa"]])

export default __exports__